import InputTaxRegNo from "./InputTaxRegNo.vue";
import HelperTaxRegNo from "./HelperTaxRegNo.vue";

export { InputTaxRegNo, HelperTaxRegNo };
